import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { IPageName, RecommendationSource } from '../../common/types/apiSchema';
import { SALE_CARD_QUERY_BLOB } from '../SaleCard/SaleCard.queries';

interface IGetRecommendedForYouSaleProps {
  fetchAdverts: boolean;
}

export const GET_RECOMMENDED_FOR_YOU_SALES: (
  props?: IGetRecommendedForYouSaleProps
) => DocumentNode = ({ fetchAdverts } = { fetchAdverts: false }) => gql`
  query Recommendations(
    $affiliate: String!
    $territory: String!
    $saleId: String!
    $userId: String!
    $attachEditorsPick: Boolean
    $limit: Int
    $source: RecommendationSource
    $isWhiteLabel: Boolean
    ${fetchAdverts ? `$page: PageName $mobile: Boolean` : ''}
  ) {
    recommendations(
      affiliate: $affiliate
      saleId: $saleId
      userId: $userId
      territory: $territory
      attachEditorsPick: $attachEditorsPick
      limit: $limit
      source: $source
      isWhiteLabel: $isWhiteLabel
    )
    ${SALE_CARD_QUERY_BLOB}
    ${
      fetchAdverts
        ? `advertisements(affiliate: $affiliate, page: $page, mobile: $mobile) {
        script
        placementKey
      }`
        : ''
    }
  }
`;

export interface IRecommendedForYouQueryVariables {
  affiliate: string;
  saleId: string;
  userId: string;
  territory: string;
  isWhiteLabel: boolean;
  attachEditorsPick?: boolean;
  limit?: number;
  source: RecommendationSource;
  page?: IPageName;
  mobile?: boolean;
}
